export default __webpack_public_path__ + "static/genesis_commander-6ddcd3f6329d379733a95e993f6639b0.png";